<template>
  <div class="flex flex-col gap-sm rounded-md bg-avtalat-gray p-sm">
    <slot></slot>
  </div>
</template>
